import React, { createContext, useState } from 'react';

export const VehicleContext = createContext();

export  const VehicleProvider=({ children }) =>{
    const [vehicles,setVehicles]=useState({})
    return (
        <VehicleContext.Provider value={{ vehicles, setVehicles}}>
            {children}
        </VehicleContext.Provider>
    );
}
